<template>
  <table class="data-table game-table">
    <colgroup>
      <col style="width: 60px"/>
      <col/>
      <col style="width: 100px"/>
      <col style="width: 130px"/>
      <col style="width: 70px"/>
      <col style="width: 40px"/>
      <col style="width: 40px"/>
      <col style="width: 40px"/>
      <col style="width: 70px"/>
    </colgroup>
    <thead>
    <tr>
      <th>День</th>
      <th>Игра</th>
      <th>Платформа</th>
      <th>Жанр</th>
      <th>Регион</th>
      <th title="Рейтинг">
        <font-awesome-icon icon="star"></font-awesome-icon>
      </th>
      <th title="Сложность">
        <font-awesome-icon icon="grin-beam-sweat"></font-awesome-icon>
      </th>
      <th title="Пуканометр">
        <font-awesome-icon icon="fire"></font-awesome-icon>
      </th>
      <th>Время</th>
      <th>Комментарий</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="game in games" :key="game.id" :class="game.statusClass" :title="game.statusName">
      <td :title="dayTitle(game)">
        <template v-if="game.dayStarted">
          <template v-if="!game.dayEnded">
            <span>{{ game.dayStarted }}</span>
          </template>
          <template v-else>
            <template v-if="game.dayStarted === game.dayEnded">
              {{ game.dayStarted }}
            </template>
            <template v-else>
              {{ game.dayStarted }} - {{ game.dayEnded }}
            </template>
          </template>
        </template>
      </td>
      <td>{{ game.gameName }}</td>
      <td>{{ game.platformName }}</td>
      <td>{{ game.genreName }}</td>
      <td>{{ game.region }}</td>
      <td>{{ game.rate }}</td>
      <td>{{ game.difficulty }}</td>
      <td>{{ game.rageMeter }}</td>
      <td>{{ game.durationFormatted }}</td>
      <td>{{ game.comment }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import ApiService from "@/services/api-service";

export default {
  name: "GameList",
  data: function () {
    return {
      games: []
    }
  },
  props: ["seasonNumber"],
  methods: {
    dayTitle(game) {
      let date = ""
      if (game.dateStarted && game.dateEnded) {
        date = `${game.dateStartedFormatted} - ${game.dateEndedFormatted} `
      } else if (game.dateStartedFormatted){
        date = `${game.dateStartedFormatted} `
      }

      let number = game.completedGameNumber !== null ? `(${game.completedGameNumber})` : ""
      return date + number
    }
  },
  mounted() {
    ApiService.get(`rgg/season/${this.seasonNumber}/games`).then(response => {
      this.games = response.data
    })
  }
}
</script>

<style scoped>
.game-table .rolled {
  background-color: #0385c3;
}

.game-table .started {
  background-color: #019b8c;
}

.game-table .reroll {
  background-color: #6a6a6a;
}

.game-table .completed {
  background-color: #3c743c;
}

.game-table .dropped {
  background-color: #870000;
}
</style>